<p-progressBar [value]="progress() ?? 0" [mode]="primeNgMode()" [showValue]="primeNgMode() === 'determinate'" />
<div class="progress-bar-label text-center w-full mt-2">
  {{ progressMessage() ?? initialMessage() }}
</div>

<!-- Always present (collapsed while there are no lanes), see `laneBlock`. Spacing is padding of the inner elements
     (12px above the first lane, 8px between lanes), so the height animations do not leave margins/gaps behind. -->
<div class="overflow-hidden" [@laneBlock]="lanesExpanded() ? 'expanded' : 'collapsed'">
  <div class="progress-bar-lanes pt-1">
    <!-- Slots are tracked by position and never removed while the block is expanded: only an added slot animates
         the height. A lane taking over the slot of a finished one must not leave/enter (both animating at once makes
         the height wobble). -->
    @for (slot of renderedLanes(); track $index) {
      <div @laneReveal>
        <!-- Re-creates the lane when another run takes over the slot (also a restart of the same key), so its bar
             starts fresh instead of animating back from 100 %. -->
        @for (lane of [slot]; track lane.run) {
          <div
            @laneSwap
            class="progress-bar-lane pt-2 transition-opacity"
            [class.opacity-50]="lane.done"
            role="group"
            [attr.aria-label]="lane.label ?? lane.key"
          >
            <div class="flex justify-between gap-2 text-caption-text-regular">
              <span class="truncate" [title]="lane.label ?? lane.key">{{ lane.label ?? lane.key }}</span>
              @if (lane.progress != null) {
                <span class="shrink-0">{{ lane.progress }}%</span>
              }
            </div>
            <p-progressBar [value]="lane.progress ?? 0" [showValue]="false" [style]="{ height: '6px' }" />
            <!-- Always one line high, so a message appearing/disappearing does not change the height. -->
            <div class="text-caption-text-regular truncate" [attr.title]="lane.message">
              @if (lane.message) {
                {{ lane.message }}
              } @else {
                &nbsp;
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
